import { ValidatorFn } from '@angular/forms';

const EMAIL_REGEX = /^[A-Za-z0-9.-]{3,}@[A-Za-z0-9.-]{3,}\.[A-Za-z.-]{2,3}$/;

export class EmailValidators {
  static email(message = 'Value must be a valid email address'): ValidatorFn {
    return (control) => {
      const value = control.value ?? '';

      return EMAIL_REGEX.test(value) ? null : { email: message };
    };
  }

  static emailArray(message = 'All values must be valid email addresses'): ValidatorFn {
    return (control) => {
      const values = control.value as string[] | null;

      if (!values?.length) {
        return null;
      }

      return values.every((v) => EMAIL_REGEX.test(v)) ? null : { emailArray: message };
    };
  }
}
